import React, { useRef, useState, useEffect } from "react";
import * as faceapi from "face-api.js";

const FaceTracker = () => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [isTracking, setIsTracking] = useState(false);
  const [modelsLoaded, setModelsLoaded] = useState(false);
  const [data, setData] =useState([]);

  useEffect(() => {
    // Load face-api models from public/models directory
    const loadModels = async () => {
      try {
        console.log("Loading models...");
        setData("Loading models...");
        await faceapi.nets.tinyFaceDetector.loadFromUri("/models");
        await faceapi.nets.faceLandmark68Net.loadFromUri("/models");
        await faceapi.nets.faceExpressionNet.loadFromUri("/models");
        setModelsLoaded(true);
        console.log("Models loaded successfully");
        setData("Models loaded successfully");
      } catch (error) {
        console.error("Error loading models: ", error);
        setData("Error loading models");
      }
    };

    loadModels();
  }, []);

  const startVideo = () => {
    navigator.mediaDevices.getUserMedia({ video: {} })
      .then((stream) => {
        videoRef.current.srcObject = stream;
        console.log("Video stream started");
        setData("Video stream started");
      })
      .catch((err) => {
        console.error("Error starting video stream: ", err);
        setData("Error starting video stream: ");
      });
  };

  const stopVideo = () => {
    if (videoRef.current.srcObject) {
      videoRef.current.srcObject.getTracks().forEach(track => track.stop());
      console.log("Video stream stopped");
      setData("Video stream stopped");
    }
  };

  const detectFaces = async () => {
    if (videoRef.current && modelsLoaded) {
      const displaySize = { width: videoRef.current.width, height: videoRef.current.height };
      faceapi.matchDimensions(canvasRef.current, displaySize);

      const detections = await faceapi.detectAllFaces(videoRef.current, new faceapi.TinyFaceDetectorOptions())
        .withFaceLandmarks()
        .withFaceExpressions();

      console.log("Detections: ", detections);
      setData("Detections: ", detections);

      const resizedDetections = faceapi.resizeResults(detections, displaySize);
      canvasRef.current.getContext('2d').clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
      faceapi.draw.drawDetections(canvasRef.current, resizedDetections);
      faceapi.draw.drawFaceLandmarks(canvasRef.current, resizedDetections);
      faceapi.draw.drawFaceExpressions(canvasRef.current, resizedDetections);
    }
  };

  const startTracking = () => {
    if (modelsLoaded) {
      startVideo();
      setIsTracking(true);
    }
  };

  const stopTracking = () => {
    stopVideo();
    setIsTracking(false);
    const context = canvasRef.current.getContext('2d');
    context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
  };

  useEffect(() => {
    let interval;
    if (isTracking) {
      interval = setInterval(detectFaces, 1); // Detect faces every 100ms
    }
    return () => clearInterval(interval);
  }, [isTracking, modelsLoaded]);

  return (
    <div className="face-tracker-container">
      <h1>Face Tracking Interface</h1>
      <div className="controls">
        <button onClick={startTracking} disabled={isTracking || !modelsLoaded} className="start-btn">
          Start Tracking
        </button>
        <button onClick={stopTracking} disabled={!isTracking} className="stop-btn">
          Stop Tracking
        </button>
      </div>
      <div className="contents">
        <div className="video-container">
          <video ref={videoRef} width="640" height="480" autoPlay muted />
          <canvas ref={canvasRef} width="640" height="480" className="overlay" />
        </div>
      </div>      
    </div>
  );
};

export default FaceTracker;
